import script from "./ActivityTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActivityTab.vue?vue&type=script&lang=ts&setup=true"

import "./ActivityTab.vue?vue&type=style&index=0&id=6c5dc244&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5dc244"]])

export default __exports__